<template>
  <v-row justify="center">
    <v-dialog
      persistent
      v-model="displayed"
      scrollable
      max-width="800"
      @click:outside="cancel"
    >
      <v-card>
        <v-card-title>Upload files</v-card-title>
        <v-divider></v-divider>

        <v-card-text max-height="600">
          <!--UPLOAD-->
          <v-form enctype="multipart/form-data" novalidate>
            <div class="dropbox">
              <v-file-input
                multiple
                ref="fileUploadField"
                v-model="files"
                @change="filesChange"
                @click="handleFileInputClick"
                label="File input"
              />
              <p>Click to browse</p>
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn v-on:click="cancel">cancel</v-btn>
          <v-btn v-on:click="done">done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3
export default {
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      name: 'Upload',
      currentStatus: null,
      files: null,
      formData: {},
      displayed: false,
      uploadedFiles: null,
      uploadError: ''
    }
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED
    }
  },
  created: function() {},
  watch: {
    showDialog(newValue) {
      this.displayed = newValue
    }
  },
  updated() {},
  methods: {
    cancel: function() {
      this.displayed = false
      this.$emit('cancel')
      this.init()
    },
    done: function() {
      this.save(this.formData).then(rec => {
        this.displayed = false
        this.$emit('done', rec)
        this.init()
      })
    },
    save: function(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING

      return this.$store
        .dispatch('MediaStore/uploadFiles', {
          files: formData
        })
        .then(res => {
          this.currentStatus = STATUS_SUCCESS
          this.init()
          return res
        })
        .catch(err => {
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
        })
    },
    async filesChange() {
      // handle file changes

      //   console.log("FILE LIST:", fileList);
      //   const formData = new FormData();

      //   if (!fileList.length) return;

      //   // append the files to FormData
      //   Array.from(Array(fileList.length).keys()).map(x => {
      //     console.log(
      //       "HERE " + fieldName + " " + fileList[x] + " " + fileList[x].name
      //     );
      //     formData.append(fieldName, fileList[x], fileList[x].name);
      //   });

      let fileList = this.files

      let files = []
      const formData = new FormData()
      if (
        fileList === null ||
        typeof fileList === 'undefined' ||
        !fileList.length
      )
        return

      // append the files to FormData
      // //   const files = fileList;
      for (let i = 0; i < fileList.length; i++) {
        files.push({
          name: fileList[i].name,
          file: fileList[i]
        })
        formData.append(`file${i}`, fileList[i], fileList[i].name)
      }

      // save it
      // Display the key/value pairs
      for (let pair of formData.entries()) {
      }
      this.formData = formData
    },
    handleFileInputClick() {
      this.$refs.fileUploadField.value = null
    },
    init() {
      this.files = null
      this.formData = {}
      this.uploadedFiles = null
      this.uploadError = ''
    }
  }
}
</script>

<style scoped></style>
